export * from './src/disclosures/BankingGeneralDisclosure';
export * from './src/disclosures/CashApyDisclosure';
export * from './src/disclosures/CashBackDisclosure';
export * from './src/disclosures/FdicDisclosure';
export * from './src/disclosures/InvestmentManagementAgreementDisclosure';
export * from './src/disclosures/InvestmentManagementDisclosure';
export {
    BANKING_GENERAL_DISCLOSURE_TEXT,
    INVESTMENT_FRUITFUL_WHOLLY_OWNED,
    INVESTMENT_NOT_FDIC_INSURED,
} from './src/disclosures/legal';
